export default __webpack_public_path__ + "static/media/gift-grey.564fc0ab.svg";